import type { Skill } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

/* istanbul ignore next */
const { useUpdate: useUserDeclaredSkillsUpdate, useGet: useUserDeclaredSkills } = getCRUDHooks<
  Skill[]
>({
  entityName: 'userDeclaredSkills',
  update: (skills, { userId }) =>
    clientApi.getOCClient().helpers.user.users.updateUserDeclaredSkills(userId, skills),
  get: ({ userId }) => clientApi.getOCClient().helpers.user.users.getUserDeclaredSkills(userId),
});

export { useUserDeclaredSkillsUpdate, useUserDeclaredSkills };
